export { default as CenterRecommendation } from './center-recommendation';
export { default as CourseRecommendation } from './course-recommendation';
export { default as Result } from './result';
export { default as ResultFooter } from './result-footer';
export * from './result-skeleton';
export { default as ResultsCard } from './results-card';
export { default as XpModal } from './xp-modal';

